import * as ORGANISATION_UUIDS from 'common/constant/organisation-uuids'
import * as USER_TYPE from 'constant/user-types'

// Cosmetic, like the other client-side admin checks: the server enforces it.
// Mirrors the server's isPlAdminUser, which compares the role by UUID; the
// client only has the role's name.
export const isPlAdmin = (user) =>
  user?.user_type?.name === USER_TYPE.ADMIN &&
  (user.organisations || []).some((organisation) => organisation?.uuid === ORGANISATION_UUIDS.PL)
